import { render, staticRenderFns } from "./DendaPenalti.vue?vue&type=template&id=4b945dcc&"
import script from "./DendaPenalti.vue?vue&type=script&lang=js&"
export * from "./DendaPenalti.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports